import styled from 'styled-components';

export const ErrorGenericContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: var(--allie-spacing-3xl) var(--allie-spacing-xl);
  background: none;
  text-align: center;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--allie-spacing-3xl);
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--allie-spacing-lg);
  max-width: 340px;
  margin-bottom: var(--allie-spacing-3xl);
`;

export const ButtonContainer = styled.div`
  width: 100%;
  max-width: 320px;
`;
